import React, { Component } from 'react'
import { HeaderView } from '@merchant-backend/common-components'
import styles from './style.module.less'
import { observer } from 'mobx-react'
import indexStore from '../List/store'
import { JUKE_PATH_A } from '@constant'

@observer
export default class extends Component {
  componentDidMount() {
    indexStore.getPoint()
  }

  render() {
    let header = [<a href={JUKE_PATH_A}>聚客宝</a>, '活动点充值']

    const { all_points, unit_price, active, hot, is_valid } = indexStore
    let _hot = []
    all_points.forEach((item, index) => {
      hot.forEach(p => {
        if (item == p) {
          _hot[index] = true
        } else {
          _hot[index] = false
        }
      })
    })

    return (
      <HeaderView title="活动点充值" header={header}>
        <div className={styles.box}>
          <ul>
            {all_points.map((item, index) => (
              <li
                key={index}
                className={index == active ? styles.checked : ''}
                onClick={indexStore.doCheckClick(index, item)}
              >
                <div>
                  <span>{item}</span>点
                </div>
                <p>
                  <span>{item * unit_price}</span>元
                </p>
                <i />
              </li>
            ))}
          </ul>

          <div className={styles.btn}>
            <a
              href={
                is_valid
                  ? `${JUKE_PATH_A}/pay?num=${all_points[active]}&give=${
                      all_points[active]
                    }`
                  : `${JUKE_PATH_A}/pay?num=${all_points[active]}`
              }
            >
              立即充值
            </a>
          </div>
        </div>
      </HeaderView>
    )
  }
}
